import {ActionTypes} from '../actions';
import {ActionTypes as InternalOrdersTypes} from '../../binning/actions';
import createReducer from '../../common/util/createReducer';

const updateItemInfo = (currentValues, action) => {
  if (!currentValues) {
    return currentValues;
  }

  const {detail} = currentValues;
  if (detail) {
    return {
      ...currentValues,
      'detail': [
        ...detail.slice(0, action.payload),
        {...detail[action.payload], ...action.response.data},
        ...detail.slice(action.payload + 1),
      ],
    };
  }

  return {...currentValues};
};

export const transferForm = (state, action) => {
  return createReducer(
    {},
    {
      [ActionTypes.CREATING_NEW_TRANSFER]: (state, action) => ({
        ...state,
        'loading': true,
      }),
      [ActionTypes.CREATED_NEW_TRANSFER]: (state, action) => ({
        ...state,
        'loading': false,
        'values': action.response.data,
      }),
      [ActionTypes.CREATED_NEW_TRANSFER_FAILED]: (state, action) => ({
        ...state,
        'loading': false,
      }),
      [ActionTypes.PROCESSING_STOCK_TRANSFER]: (state, action) => ({
        ...state,
        'loading': true,
      }),
      [ActionTypes.PROCESSED_STOCK_TRANSFER]: (state, action) => ({
        ...state,
        'loading': false,
        'values': action.response.data,
      }),
      [ActionTypes.PROCESSED_STOCK_TRANSFER_FAILED]: (state, action) => ({
        ...state,
        'loading': false,
      }),
      [InternalOrdersTypes.VERIFYING_STOCK_IN_WAREHOUSE]: (state, action) => ({
        ...state,
        'gettingInfo': true,
        'loading': true,
      }),
      [InternalOrdersTypes.VERIFIED_STOCK_IN_WAREHOUSE]: (state, action) => ({
        ...state,
        'loading': false,
        'gettingInfo': false,
        'currentIndex': action.payload,
        'values': updateItemInfo(state.values, action),
      }),
      [InternalOrdersTypes.VERIFIED_STOCK_IN_WAREHOUSE_FAILED]: (
        state,
        action
      ) => ({
        ...state,
        'loading': false,
        'gettingInfo': false,
        'currentIndex': null,
      }),
      [ActionTypes.ADDING_TRANSFER_ITEM]: (state, action) => ({
        ...state,
        'loading': true,
      }),
      [ActionTypes.ADDED_TRANSFER_ITEM]: (state, action) => ({
        ...state,
        'loading': false,
        'currentIndex': null,
        'values': {
          ...state.values,
          'detail': [
            ...state.values.detail.slice(0, action.payload),
            {...state.values.detail[action.payload], ...action.response.data},
            ...state.values.detail.slice(action.payload + 1),
            {},
          ],
        },
      }),
      [ActionTypes.ADDED_TRANSFER_ITEM_FAILED]: (state, action) => ({
        ...state,
        'loading': false,
      }),
      [ActionTypes.REMOVING_TRANSFER_ITEM]: (state, action) => ({
        ...state,
        'loading': true,
      }),
      [ActionTypes.REMOVED_TRANSFER_ITEM_FAILED]: (state, action) => ({
        ...state,
        'loading': false,
      }),
      [ActionTypes.REMOVED_TRANSFER_ITEM]: (state, action) => ({
        ...state,
        'loading': false,
        'currentIndex': null,
        'values': {
          ...state.values,
          'detail': [
            ...state.values.detail.slice(0, action.payload),
            ...state.values.detail.slice(action.payload + 1),
          ],
        },
      }),
      [ActionTypes.REJECTING_TRANSFER]: (state, action) => ({
        ...state,
        'loading': true,
      }),
      [ActionTypes.REJECTED_TRANSFER_FAILED]: (state, action) => ({
        ...state,
        'loading': false,
      }),
      [ActionTypes.REJECTED_TRANSFER]: (state, action) => ({
        ...state,
        'loading': false,
        'values': {},
      }),
      [ActionTypes.SUBMITTING_TRANSFER]: (state, action) => ({
        ...state,
        'loading': true,
      }),
      [ActionTypes.SUBMITTED_TRANSFER_FAILED]: (state, action) => ({
        ...state,
        'loading': false,
      }),
      [ActionTypes.SUBMITTED_TRANSFER]: (state, action) => ({
        ...state,
        'loading': false,
        'values': {},
      }),
    }
  )(state, action);
};
